import { c as _c } from "react/compiler-runtime";
import React, { useState, useRef, useEffect } from "react";
import EmojiPicker from "emoji-picker-react";
const EmojiInput = t0 => {
  const $ = _c(34);
  const {
    message,
    handleInputChange,
    sendMessage,
    HandleUploadFiles: t1,
    selectedImage,
    loading,
    disabled: t2,
    placeholder: t3,
    maxLength
  } = t0;
  const HandleUploadFiles = t1 === undefined ? null : t1;
  const disabled = t2 === undefined ? false : t2;
  const placeholder = t3 === undefined ? "Message..." : t3;
  const [showEmojiPicker, setShowEmojiPicker] = useState(false);
  const inputRef = useRef(null);
  const emojiPickerRef = useRef(null);
  const emojiTriggerRef = useRef(null);
  const fileInputRef = useRef(null);
  let t4;
  let t5;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      const handleClickOutside = event => {
        if (emojiPickerRef.current && !emojiPickerRef.current.contains(event.target) && !inputRef.current?.contains(event.target) && !emojiTriggerRef.current?.contains(event.target)) {
          setShowEmojiPicker(false);
        }
      };
      document.addEventListener("mousedown", handleClickOutside);
      return () => {
        document.removeEventListener("mousedown", handleClickOutside);
      };
    };
    t5 = [];
    $[0] = t4;
    $[1] = t5;
  } else {
    t4 = $[0];
    t5 = $[1];
  }
  useEffect(t4, t5);
  let t6;
  if ($[2] !== handleInputChange || $[3] !== message) {
    t6 = (event_0, emojiObject) => {
      const emoji = event_0.emoji || "";
      const {
        selectionStart,
        selectionEnd
      } = inputRef.current;
      const newText = message.slice(0, selectionStart) + emoji + message.slice(selectionEnd);
      handleInputChange({
        target: {
          value: newText
        }
      });
      setTimeout(() => {
        inputRef.current.selectionStart = inputRef.current.selectionEnd = selectionStart + emoji.length;
      }, 0);
    };
    $[2] = handleInputChange;
    $[3] = message;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  const onEmojiClick = t6;
  let t7;
  if ($[5] !== disabled || $[6] !== loading || $[7] !== sendMessage) {
    t7 = event_1 => {
      if (disabled || loading || event_1.nativeEvent.isComposing || event_1.nativeEvent.keyCode === 229) {
        return;
      }
      if (event_1.key === "Enter" && !event_1.shiftKey) {
        event_1.preventDefault();
        setShowEmojiPicker(false);
        if (!event_1.repeat) {
          sendMessage(event_1);
        }
      }
    };
    $[5] = disabled;
    $[6] = loading;
    $[7] = sendMessage;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const handleKeyDown = t7;
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = () => {
      if (inputRef.current) {
        inputRef.current.style.height = "auto";
        inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
      }
    };
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  const autoResize = t8;
  let t10;
  let t9;
  if ($[10] !== message) {
    t9 = () => {
      if (message) {
        autoResize();
      } else {
        if (inputRef.current) {
          inputRef.current.style.height = "auto";
        }
      }
    };
    t10 = [message];
    $[10] = message;
    $[11] = t10;
    $[12] = t9;
  } else {
    t10 = $[11];
    t9 = $[12];
  }
  useEffect(t9, t10);
  let t11;
  if ($[13] !== HandleUploadFiles || $[14] !== disabled || $[15] !== handleInputChange || $[16] !== handleKeyDown || $[17] !== loading || $[18] !== maxLength || $[19] !== message || $[20] !== onEmojiClick || $[21] !== placeholder || $[22] !== selectedImage || $[23] !== sendMessage || $[24] !== showEmojiPicker) {
    t11 = !selectedImage && <div className="flex items-center gap-2 md:gap-3 w-full">{HandleUploadFiles && <div className="cursor-pointer flex items-center justify-start relative flex-shrink-0"><svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 32 32" fill="none" className="md:w-8 md:h-8" onClick={() => fileInputRef.current.click()}><path d="M23.6668 22.6667V10.6667C23.6668 10.1134 23.2202 9.66675 22.6668 9.66675C22.1135 9.66675 21.6668 10.1134 21.6668 10.6667V22.6667C21.6668 25.7934 19.1268 28.3334 16.0002 28.3334C12.8735 28.3334 10.3335 25.7934 10.3335 22.6667V7.33341C10.3335 5.31341 11.9802 3.66675 14.0002 3.66675C16.0202 3.66675 17.6668 5.31341 17.6668 7.33341V21.6667C17.6668 22.5867 16.9202 23.3334 16.0002 23.3334C15.0802 23.3334 14.3335 22.5867 14.3335 21.6667V8.66675C14.3335 8.11341 13.8868 7.66675 13.3335 7.66675C12.7802 7.66675 12.3335 8.11341 12.3335 8.66675V21.6667C12.3335 23.6867 13.9802 25.3334 16.0002 25.3334C18.0202 25.3334 19.6668 23.6867 19.6668 21.6667V7.33341C19.6668 4.20675 17.1268 1.66675 14.0002 1.66675C10.8735 1.66675 8.3335 4.20675 8.3335 7.33341V22.6667C8.3335 26.8934 11.7735 30.3334 16.0002 30.3334C20.2268 30.3334 23.6668 26.8934 23.6668 22.6667Z" fill="#354EF0" /></svg><input accept=".jpg,.jpeg,.png,.csv,.pdf,.txt,.doc,.docx,.pptx" ref={fileInputRef} type="file" style={{
          display: "none"
        }} onChange={HandleUploadFiles} /></div>}<div className="w-full flex gap-2 md:gap-5 px-2 md:px-4 justify-between items-center bg-neutral-100 rounded-[10px] min-w-0"><div className="flex items-center gap-2 md:gap-3 flex-1 min-w-0"><div className="relative w-5 h-5 md:w-6 md:h-6 cursor-pointer flex-shrink-0"><svg ref={emojiTriggerRef} xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" className="w-full h-full" onClick={() => {
              if (!disabled && !loading) {
                setShowEmojiPicker(!showEmojiPicker);
              }
            }}><g clipRule="url(#clip0_261_10639)"><path d="M12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0ZM12 22.5C6.201 22.5 1.5 17.799 1.5 12C1.5 6.201 6.201 1.5 12 1.5C17.799 1.5 22.5 6.201 22.5 12C22.5 17.799 17.799 22.5 12 22.5Z" fill="#8E8E8E" /><path d="M8.25 9.75C9.07843 9.75 9.75 9.07843 9.75 8.25C9.75 7.42157 9.07843 6.75 8.25 6.75C7.42157 6.75 6.75 7.42157 6.75 8.25C6.75 9.07843 7.42157 9.75 8.25 9.75Z" fill="#8E8E8E" /><path d="M15.75 9.75C16.5784 9.75 17.25 9.07843 17.25 8.25C17.25 7.42157 16.5784 6.75 15.75 6.75C14.9216 6.75 14.25 7.42157 14.25 8.25C14.25 9.07843 14.9216 9.75 15.75 9.75Z" fill="#8E8E8E" /><path d="M17.25 12C17.25 14.8995 14.8995 17.25 12 17.25C9.1005 17.25 6.75 14.8995 6.75 12H5.25C5.25 15.7279 8.27208 18.75 12 18.75C15.7279 18.75 18.75 15.7279 18.75 12H17.25Z" fill="#8E8E8E" /></g><defs><clipPath id="clip0_261_10639"><rect width="24" height="24" fill="white" /></clipPath></defs></svg>{showEmojiPicker && <div ref={emojiPickerRef} className="fixed bottom-20 left-2 right-2 sm:left-auto sm:right-auto z-50"><EmojiPicker onEmojiClick={onEmojiClick} width="100%" height={350} searchDisabled={false} skinTonesDisabled={true} previewConfig={{
                showPreview: false
              }} /></div>}</div><div className="flex-1 min-w-0 overflow-hidden"><textarea ref={inputRef} value={message} onChange={handleInputChange} onKeyDown={handleKeyDown} placeholder={placeholder} disabled={disabled || loading} maxLength={maxLength} className="w-full bg-neutral-100 max-h-24 h-auto border-none resize-none outline-none overflow-y-auto p-2 text-sm md:text-base" rows={1} /></div></div><div className={`w-[80px] md:w-[108px] h-9 md:h-10 cursor-pointer hover:shadow-lg px-2 py-1 rounded-md justify-center items-center gap-1 md:gap-[7px] inline-flex flex-shrink-0 ${!disabled && (message.trim() || selectedImage) ? "bg-[#354EF0]" : "bg-neutral-400"}`} onClick={e => {
          if (disabled || loading) {
            return;
          }
          setShowEmojiPicker(false);
          sendMessage(e);
        }}><div className="text-white text-sm md:text-base font-normal font-poppins">{loading ? "Sending" : "Send"}</div><div className="w-4 h-4 md:w-[18px] md:h-[18px] relative"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" className="w-full h-full"><g clipRule="url(#clip0_261_10655)"><path fillRule="evenodd" clipRule="evenodd" d="M12.8764 5.12359L6.93639 9.24773L0.723373 7.17645C0.289693 7.03159 -0.00247938 6.62471 1.58588e-05 6.16758C0.00254393 5.71046 0.298066 5.30607 0.733419 5.16627L16.618 0.0508648C16.9956 -0.0705155 17.41 0.0290971 17.6905 0.309582C17.9709 0.590066 18.0706 1.00447 17.9492 1.38208L12.8338 17.2666C12.694 17.702 12.2896 17.9975 11.8324 18C11.3753 18.0025 10.9684 17.7103 10.8236 17.2767L8.74225 11.0335L12.8764 5.12359Z" fill="white" /></g><defs><clipPath id="clip0_261_10655"><rect width="18" height="18" fill="white" /></clipPath></defs></svg></div></div></div></div>;
    $[13] = HandleUploadFiles;
    $[14] = disabled;
    $[15] = handleInputChange;
    $[16] = handleKeyDown;
    $[17] = loading;
    $[18] = maxLength;
    $[19] = message;
    $[20] = onEmojiClick;
    $[21] = placeholder;
    $[22] = selectedImage;
    $[23] = sendMessage;
    $[24] = showEmojiPicker;
    $[25] = t11;
  } else {
    t11 = $[25];
  }
  let t12;
  if ($[26] !== loading || $[27] !== message || $[28] !== selectedImage || $[29] !== sendMessage) {
    t12 = selectedImage && <div className="flex items-center gap-2 md:gap-3 justify-end"><div className={`w-[80px] md:w-[108px] h-9 md:h-10 cursor-pointer hover:shadow-lg px-2 py-1 rounded-md justify-center items-center gap-1 md:gap-[7px] inline-flex ${message.trim() || selectedImage ? "bg-[#354EF0]" : "bg-neutral-400"}`} onClick={e_0 => {
        setShowEmojiPicker(false);
        sendMessage(e_0);
      }}><div className="text-white text-sm md:text-base font-normal font-poppins">{loading ? "Sending" : "Send"}</div><div className="w-4 h-4 md:w-[18px] md:h-[18px] relative"><svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none" className="w-full h-full"><g clipRule="url(#clip0_261_10655)"><path fillRule="evenodd" clipRule="evenodd" d="M12.8764 5.12359L6.93639 9.24773L0.723373 7.17645C0.289693 7.03159 -0.00247938 6.62471 1.58588e-05 6.16758C0.00254393 5.71046 0.298066 5.30607 0.733419 5.16627L16.618 0.0508648C16.9956 -0.0705155 17.41 0.0290971 17.6905 0.309582C17.9709 0.590066 18.0706 1.00447 17.9492 1.38208L12.8338 17.2666C12.694 17.702 12.2896 17.9975 11.8324 18C11.3753 18.0025 10.9684 17.7103 10.8236 17.2767L8.74225 11.0335L12.8764 5.12359Z" fill="white" /></g><defs><clipPath id="clip0_261_10655"><rect width="18" height="18" fill="white" /></clipPath></defs></svg></div></div></div>;
    $[26] = loading;
    $[27] = message;
    $[28] = selectedImage;
    $[29] = sendMessage;
    $[30] = t12;
  } else {
    t12 = $[30];
  }
  let t13;
  if ($[31] !== t11 || $[32] !== t12) {
    t13 = <>{t11}{t12}</>;
    $[31] = t11;
    $[32] = t12;
    $[33] = t13;
  } else {
    t13 = $[33];
  }
  return t13;
};
export default EmojiInput;